export type BffUserClaim = { type: string; value: string };

function getReturnUrl(): string {
  const pathAndQuery = `${globalThis.location.pathname}${globalThis.location.search}`;
  return pathAndQuery.length > 0 ? pathAndQuery : '/';
}

function normalizeReturnUrl(returnPath?: string): string {
  if (!returnPath)
    return getReturnUrl();
  try {
    if (/^https?:\/\//i.test(returnPath)) {
      const parsed = new URL(returnPath);
      const relative = `${parsed.pathname}${parsed.search}`;
      return relative.length > 0 ? relative : '/';
    }
    return returnPath.startsWith('/') ? returnPath : `/${returnPath}`;
  }
  catch {
    return getReturnUrl();
  }
}

export function login(returnPath?: string): void {
  const returnUrl = normalizeReturnUrl(returnPath);
  globalThis.location.assign(`/bff/login?returnUrl=${encodeURIComponent(returnUrl)}`);
}

export function logout(logoutUrl: string): void {
  globalThis.location.assign(logoutUrl);
}

export async function fetchBffUserClaims(): Promise<BffUserClaim[] | null> {
  const response = await fetch('/bff/user', {
    credentials: 'include',
    headers: { 'X-CSRF': '1' },
  });
  if (response.status === 401 || response.status === 403)
    return null;
  if (!response.ok)
    return null;
  return (await response.json()) as BffUserClaim[];
}

export function findClaim(claims: BffUserClaim[] | null | undefined, type: string): string | undefined {
  if (!claims)
    return undefined;
  return claims.find((c) => c.type === type)?.value;
}
